/**
 * Global function used by Google reCAPTCHA.
 * Enabling reCAPTCHA for prefab forms and "Was this helpful" forms in Sitecore
 * adds the class `.recaptchaButton` to the form submit button.
 *
 */
function validateRecaptcha(onSuccess, onFailure) {

    if (typeof grecaptcha === 'undefined') {
        console.error('grecaptcha is not loaded');
        return onFailure && onFailure('grecaptcha not available');
    }

    const $config = $('#recaptcha-config');
    const siteKey = $config.data('recaptcha-sitekey');

    if (!siteKey) {
        console.error('Missing reCAPTCHA site key');
        return onFailure && onFailure('Missing site key');
    }

    grecaptcha.ready(function () {

        grecaptcha.execute(siteKey, { action: 'submit' })
            .then(function (token) {

                if (!token) {
                    console.warn('No token returned from grecaptcha');
                    return onFailure && onFailure('No reCAPTCHA token');
                }

                $.ajax({
                    type: 'POST',
                    url: '/recaptcha/validate',
                    contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                    data: { token: token },

                    success: function (res) {
                        if (res && res.Success === true) {
                            console.log('reCAPTCHA validated');
                            return onSuccess && onSuccess(res);
                        }

                        console.warn('reCAPTCHA validation failed', res);
                        return onFailure && onFailure(res);
                    },

                    error: function (xhr, status, error) {
                        console.error('reCAPTCHA request failed', error);
                        return onFailure && onFailure(error);
                    }
                });
            })
            .catch(function (err) {
                console.error('reCAPTCHA execution error', err);
                return onFailure && onFailure(err);
            });
    });
}